// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2i1qP","disabled":"FileBtn_disabled__2O6X3","warn":"FileBtn_warn__ZWHSp","fade":"FileBtn_fade__2Cr0W"};